'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequest$002dPharmacy$002dState$0024 from "./app.api.-Drug-Request-Pharmacy-State$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$41() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$41 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$41 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$41.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$41.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$41;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$41() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$41 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$41 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$41.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$41.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$41.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$41.prototype.apply__O = (function() {
  return $j_app$002eapi$002e$002dDrug$002dRequest$002dPharmacy$002dState$0024.$m_Lapp_api_DrugRequestPharmacyState$().derived$Schema__Lsttp_tapir_Schema();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$41 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$41, "app.api.DrugRequestsAcceptedListItem$$anon$41", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$41: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$41 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$41 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$41.js.map
